(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-v-products]').forEach(section => {
      if (section.dataset.vReady) return;
      section.dataset.vReady = 'true';
      const rail = section.querySelector('.v-product-rail');
      const cards = [...section.querySelectorAll('[data-v-group]')];
      const count = section.querySelector('[data-v-product-count]');
      const prev = section.querySelector('[data-v-prev]');
      const next = section.querySelector('[data-v-next]');
      const update = () => {
        const total = cards.filter(card => !card.hidden).length;
        if (count) count.textContent = `${total} ${total === 1 ? 'essential' : 'essentials'}`;
        if (prev) prev.disabled = rail.scrollLeft <= 2;
        if (next) next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
      };
      section.querySelectorAll('[data-v-filter]').forEach(button => button.addEventListener('click', () => {
        section.querySelectorAll('[data-v-filter]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        cards.forEach(card => { card.hidden = button.dataset.vFilter !== 'all' && card.dataset.vGroup !== button.dataset.vFilter; });
        rail.scrollLeft = 0;
        update();
      }));
      const move = direction => rail.scrollBy({ left: direction * (rail.clientWidth * .85), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      prev?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));
      rail.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(rail);
      update();
    });
    root.querySelectorAll('[data-v-gallery]').forEach(gallery => {
      if (gallery.dataset.vReady) return;
      gallery.dataset.vReady = 'true';
      const image = gallery.querySelector('[data-v-main-image]');
      const caption = gallery.querySelector('[data-v-caption]');
      const form = document.getElementById(gallery.dataset.vForm);
      const frontButton = gallery.querySelector('[data-v-front]');
      const flatButton = gallery.querySelector('[data-v-flat]');
      form?.addEventListener('variant:change', event => {
        const colour = String(event.detail.variant?.option1 || 'Black');
        const key = colour.toLowerCase();
        const src = gallery.getAttribute('data-v-' + key);
        if (!src) return;
        const alt = `Velora ${colour} Bluetooth sleep mask with branded controls`;
        image.src = src;
        image.removeAttribute('srcset');
        image.alt = alt;
        if (caption) caption.textContent = alt;
        if (frontButton) {
          frontButton.dataset.vImage = src;
          frontButton.dataset.vAlt = alt;
          frontButton.querySelector('img').src = src;
          frontButton.setAttribute('aria-pressed', 'true');
        }
        if (flatButton) {
          flatButton.hidden = key !== 'black';
          flatButton.setAttribute('aria-pressed', 'false');
        }
      });
      gallery.querySelectorAll('[data-v-image]').forEach(button => button.addEventListener('click', () => {
        image.src = button.dataset.vImage;
        image.removeAttribute('srcset');
        image.alt = button.dataset.vAlt;
        if (caption) caption.textContent = button.dataset.vAlt;
        gallery.querySelectorAll('[data-v-image]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      }));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
